// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"a0b6ca58","245":"64bc5db6","357":"8348ea5f","447":"ba8841bf","588":"7ecd6afd","967":"58a95652"}[chunkId] + ".chunk.js";
};